import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtils } from '../utils/date-utils';

export class DateValidators {
  static presentOrFuture(control: FormControl<Date | null>): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const today = DateUtils.dateToIsoDateOnly(new Date());
    const target = DateUtils.dateToIsoDateOnly(control.value, true);

    return target.localeCompare(today) >= 0 ? null : { invalidDate: $localize`Date is in the past` };
  }

  static future(control: FormControl<Date | null>): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const today = DateUtils.dateToIsoDateOnly(new Date());
    const target = DateUtils.dateToIsoDateOnly(control.value, true);

    return target.localeCompare(today) > 0 ? null : { invalidDate: $localize`Date is in the past or present` };
  }

  static beforeOrOnDate(
    endDateFormControl: AbstractControl,
    startName: string = $localize`Start Date`,
    endName: string = $localize`End Date`,
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !endDateFormControl.value) {
        return null;
      }

      const startDate = DateUtils.dateToIsoDateOnly(control.value, true);
      const endDate = DateUtils.dateToIsoDateOnly(endDateFormControl.value, true);

      return startDate.localeCompare(endDate) > 0
        ? { invalidDate: startName + $localize` cannot be after ` + endName }
        : null;
    };
  }
}
